<!--导入报价订单-->
<template>
    <div class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-right">
                <div class="search-name">订单数据上传的Excel模板</div>
                <el-button type="text" class="search-btn" @click="downFile()">点击下载</el-button>
                <el-upload
                    :action="url"
                    :headers="headerObj"
                    :on-error="uploadErr"
                    accept=".xls,.xlsx"
                    :show-file-list="false"
                    :before-upload="beforeUpload"
                    :on-success="uploadSuccess"
                    :readonly="saveLoading || loading"
                    v-loading.fullscreen.lock="loading"
                >
                    <el-button size="small" icon="fa fa-file-excel-o" class="search-btn btn-primary"> 选择文件</el-button>
                </el-upload>
                <el-button size="small" icon="el-icon-upload" class="search-btn btn-primary" @click="handleExport" :readonly="saveLoading">保存数据</el-button>
                <div class="explain">（* 同一个客户会创建同一张订单。）</div>
            </div>
        </div>

        <div class="table-ctn u-table-ctn">
            <u-table use-virtual :header-cell-style="{ background: '#F2F6FC' }" :border="true" :data="tableData" height="670" :row-height="34" style="width: 100%">
                <u-table-column label="客户" show-overflow-tooltip min-width="100px" prop="CustName">
                    <template slot="header" slot-scope="scope">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">如果系统中不存在该客户会创建客户数据。</div>
                            <span>
                                <i class="el-icon-warning-outline"></i>
                            </span>
                        </el-tooltip>
                        客户
                    </template>
                </u-table-column>
                <u-table-column label="电话" show-overflow-tooltip min-width="100px" prop="CustPhone"></u-table-column>
                <u-table-column label="询价日期" show-overflow-tooltip min-width="80px" prop="ITime"> </u-table-column>
                <u-table-column label="报价日期" show-overflow-tooltip min-width="80px" prop="QTime"> </u-table-column>
                <!-- <u-table-column label="业务员" show-overflow-tooltip width="90px" prop="SName">
                    <template slot="header" slot-scope="scope">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">业务员需为系统内有的员工账号</div>
                            <span>
                                <i class="el-icon-warning-outline"></i>
                            </span>
                        </el-tooltip>
                        业务员
                    </template>
                </u-table-column> -->
                <u-table-column label="运费" show-overflow-tooltip width="140px" prop="PriceSumShip">
                    <template slot="header" slot-scope="scope">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                可空，但必须大于零
                            </div>
                            <span>
                                <i class="el-icon-warning-outline"></i>
                            </span>
                        </el-tooltip>
                        运费
                    </template>
                </u-table-column>
                <u-table-column label="出仓仓库" show-overflow-tooltip width="140px" prop="StoName">
                    <template slot="header" slot-scope="scope">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                如果系统内不存在该仓库会创建新的仓库数据
                            </div>
                            <span>
                                <i class="el-icon-warning-outline"></i>
                            </span>
                        </el-tooltip>
                        出仓仓库
                    </template>
                </u-table-column>
                <u-table-column label="收货地址" show-overflow-tooltip width="140px" prop="Addr"></u-table-column>
                <u-table-column label="客人要求" show-overflow-tooltip width="100px" prop="Remark"></u-table-column>
                <u-table-column label="配件编码" show-overflow-tooltip width="120px" prop="APCode">
                    <template slot="header" slot-scope="scope">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">配件唯一标识，系统中不存在会新增配件数据</div>
                            <span>
                                <i class="el-icon-warning-outline"></i>
                            </span>
                        </el-tooltip>
                        配件编码
                    </template>
                </u-table-column>
                <u-table-column label="配件名" show-overflow-tooltip width="120px" prop="APName"></u-table-column>
                <u-table-column label="车型" show-overflow-tooltip min-width="120px" prop="AutoSeries"></u-table-column>
                <u-table-column label="单位" show-overflow-tooltip min-width="80px" prop="Unit"></u-table-column>
                <u-table-column label="数量" show-overflow-tooltip width="80px" prop="Count">
                    <template slot="header" slot-scope="scope">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">大于零的正整数</div>
                            <span>
                                <i class="el-icon-warning-outline"></i>
                            </span>
                        </el-tooltip>
                        数量
                    </template>
                </u-table-column>
                <u-table-column label="售价" show-overflow-tooltip width="100px" prop="Price">
                    <template slot="header" slot-scope="scope">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">可空或者为零，但必须大于零</div>
                            <span>
                                <i class="el-icon-warning-outline"></i>
                            </span>
                        </el-tooltip>
                        售价
                    </template>
                </u-table-column>
            </u-table>
        </div>
        <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            pageTitle: '导入Excel',
            loading: false,
            saveLoading: false,
            tableData: [],
            phonenumList: [], //号码集合，不重复的
            userId: userMsg.EmployeeId,
            entpId: userMsg.EntpId,
            url: '/api/UploadFile/UploadQuotationOrderExcel',
            headerObj: {
                'access-key': userMsg.Token,
                reqApp: 'yqgPC'
            },
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            addCount: 0, //新增订单数
            jumpCount: 0, //跳过订单数
            recordId: ''
        };
    },
    mounted() {},
    methods: {
        downFile() {
            let a = document.createElement('a');
            a.href = `/download/报价单导入模板.xlsx`; // 这里的请求方式为get，如果需要认证，接口上需要带上token
            a.target = '_blank';
            a.click();
        },
        uploadSuccess(res) {
            if (res.errcode == 0) {
                this.tableData = res.data;
                if (res.data && res.data.length > 0) {
                    let arr = [0, 1, 2, 3, 4];
                    res.data.forEach((val, idx) => (arr[idx] = val.CustPhone));
                    this.phonenumList = Array.from(new Set(arr));
                }
            } else {
                this.$util.errorMsg(res.errmsg);
            }
            this.loading = false;
        },
        uploadErr(error) {
            this.loading = false;
            const result = JSON.parse(error.message);
            this.$util.errorMsg(result.message);
        },
        beforeUpload(file) {
            this.loading = true;
            this.tableData = [];
            this.phonenumList = [];
            this.addCount = 0;
            this.jumpCount = 0;
        },
        handleExport() {
            let that = this;
            if (!that.tableData || that.tableData.length == 0) {
                that.$util.warningMsg('请选择文件');
                return;
            }
            that.saveLoading = true;

            if (that.saveCount == 0) that.uploadStartRecords('上传报价数据总数：' + that.tableData.length);

            //每次取100条数据
            let apList = [];

            let start = that.saveCount;
            let newtableData = that.tableData.slice(start, that.tableData.length);

            for (let i = 0; i < that.phonenumList.length; i++) {
                let phone = that.phonenumList[i];
                let result = newtableData.filter(item => item.CustPhone == phone);
                apList = apList.concat(result);
                if (apList.length >= 100 || apList.length + that.saveCount >= that.tableData.length) break;
            }

            that.$util
                .axiosPost({
                    url: '/api/EntpQuotationOrder/ImportQuotationOrder',
                    data: {
                        UserId: that.userId,
                        EntpId: that.entpId,
                        BJOrdersList: apList
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.saveCount += apList.length;
                        let num = parseFloat(that.saveCount);
                        let total = parseFloat(that.tableData.length);
                        that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                        that.percentage = that.percentage > 100 ? 100 : that.percentage;
                        if (res.data) {
                            that.addCount += Number(res.data.addCount);
                            that.editCount += Number(res.data.editCount);
                            that.jumpCount += Number(res.data.jumpCount);
                        }

                        if (that.tableData.length <= that.saveCount) {
                            setTimeout(function () {
                                that.saveLoading = false;
                                let msg = `导入订单数${that.addCount}，跳过订单数${that.jumpCount}`;
                                that.$alert(msg, '保存成功', { confirmButtonText: '确定' });

                                that.percentage = 0;
                                that.currtPage = 1;
                                that.saveCount = 0;
                                that.tableData = [];
                                that.phonenumList = [];
                                that.addCount = 0;
                                that.jumpCount = 0;
                                that.$store.commit('updateNeedRefresh', true);

                                that.uploadEndRecords(msg);
                            }, 1000);
                        } else {
                            that.currtPage++;
                            //删除已经保存的号码
                            apList.forEach(function (item, i) {
                                var index = that.phonenumList.findIndex(val => val.CustPhone == item.CustPhone);
                                if (index > -1) {
                                    that.phonenumList.splice(index, 1);
                                }
                            });
                            that.handleExport();
                        }
                    }
                })
                .catch(() => {
                    that.saveLoading = false;
                });
        },
        uploadStartRecords(desc) {
            let that = this;
            let params = { Type: 4, OpDesc: desc };
            that.$util.uploadStartRecords(params).then(res => {
                if (res.data) that.recordId = res.data;
            });
        },
        uploadEndRecords(desc) {
            let that = this;
            if (that.recordId) {
                let params = { RecordId: that.recordId, OpDesc: desc };
                that.$util.uploadEndRecords(params);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.search-btn {
    margin-left: 0;
    margin-right: 20px;
}
.explain {
    flex-shrink: 0;
    margin: 0 10px 10px;
    height: 32px;
    line-height: 32px;
    color: #ef7a82;
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 99999;
}
.el-icon-warning-outline {
    color: orange;
    margin-right: 5px;
}
</style>
